// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__c+rYQ","content":"Dashboard_content__J5p2y","section":"Dashboard_section__jR2Jx"};